module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/CMD-a4847302617403892cfb547bbc306f19.svg";